// extracted by mini-css-extract-plugin
export default {"header":"About_header__P2f9o","svg":"About_svg__NVvgA","widthBlock":"About_widthBlock__XiXua"};